var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FEE6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.75 20.75L21.75 19.5155C21.75 18.9022 21.3766 18.3506 20.8071 18.1228L19.2815 17.5126C18.5571 17.2229 17.7316 17.5367 17.3828 18.2345L17.25 18.5C17.25 18.5 15.375 18.125 13.875 16.625C12.375 15.125 12 13.25 12 13.25L12.2655 13.1172C12.9633 12.7684 13.2771 11.9429 12.9874 11.2185L12.3772 9.69291C12.1494 9.12343 11.5978 8.75 10.9845 8.75H9.75C8.92157 8.75 8.25 9.42157 8.25 10.25C8.25 16.8774 13.6226 22.25 20.25 22.25C21.0784 22.25 21.75 21.5784 21.75 20.75Z",
    fill: "#DE8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6478 12.1477C17.4281 12.3674 17.0719 12.3674 16.8523 12.1477L15.8826 11.1781C15.37 10.6655 15.37 9.83448 15.8826 9.32192L16.8523 8.35225C17.0719 8.13258 17.4281 8.13258 17.6478 8.35225C17.8674 8.57192 17.8674 8.92808 17.6478 9.14775L16.6781 10.1174C16.6049 10.1906 16.6049 10.3094 16.6781 10.3826L17.6478 11.3523C17.8674 11.5719 17.8674 11.9281 17.6478 12.1477Z",
    fill: "#DE8D8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6478 12.1477C20.4281 12.3674 20.0719 12.3674 19.8523 12.1477L18.8826 11.1781C18.37 10.6655 18.37 9.83448 18.8826 9.32192L19.8523 8.35225C20.0719 8.13258 20.4281 8.13258 20.6478 8.35225C20.8674 8.57192 20.8674 8.92808 20.6478 9.14775L20.108 9.6875H21.75C22.0607 9.6875 22.3125 9.93934 22.3125 10.25C22.3125 10.5607 22.0607 10.8125 21.75 10.8125H20.108L20.6478 11.3523C20.8674 11.5719 20.8674 11.9281 20.6478 12.1477Z",
    fill: "#DE8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPhone);
export default __webpack_public_path__ + "static/media/menu_phone.b3243023d60d809bbdd8f6322dcde498.svg";
export { ForwardRef as ReactComponent };